import 'bootstrap/js/src/offcanvas';
import 'bootstrap/js/src/dropdown';
import 'bootstrap/js/src/collapse';
import 'sharer.js';

import lozad from 'lozad';

class NorthC {
  constructor() {
    this.backToTopBtn = document.querySelector('.back-to-top');
    this.slantedElements = document.querySelectorAll('.slanted');
    this.slantedElementsInitialized = false;
  }

  /* eslint-disable no-new, class-methods-use-this */
  init() {
    NorthC.initLozad();
    this.showBackToTopBtn();
    this.passHeightOfSlantedElementsToVariable();
  }

  showBackToTopBtn() {
    let isScrolling = false;

    this.backToTopBtn.addEventListener('click', () => {
      window.scrollTo({ top: 0 });
    });

    window.addEventListener('scroll', () => {
      const lastScrollY = window.scrollY;
  
      if (!isScrolling) {
        window.requestAnimationFrame(() => {
          this.backToTopBtn.classList.toggle('visible', lastScrollY > 100);
          isScrolling = false;
        });
  
        isScrolling = true;
      }
    });
  }

  passHeightOfSlantedElementsToVariable() {
    if (!this.slantedElements || !this.slantedElements.length) {
      return;
    }

    this.slantedElements.forEach((element) => {
      element.style.setProperty('--height', `${element.offsetHeight}px`);
      element.style.setProperty('--opacity', 1);
    });

    if (!this.slantedElementsInitialized) {
      window.visualViewport.addEventListener('resize', () => {
        this.passHeightOfSlantedElementsToVariable();
      });

      const tabLinks = document.querySelectorAll('[data-bs-toggle=tab]');

      tabLinks.forEach((tabLink) => {
        tabLink.addEventListener('shown.bs.tab', () => {
          this.passHeightOfSlantedElementsToVariable();
        });
      });

      this.slantedElementsInitialized = true;
    }
  }

  static initLozad() {
    const observer = lozad('.lozad'); // lazy loads elements with default selector as '.lozad'
    observer.observe();
  }
}

new NorthC().init();
